<div class="single-select-dropdown">
  <div
    class="form-control form-select dropdown-toggle-borders"
    [class.disabled]="disabled"
    [class.show]="dropdownOpen"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="onToggle()"
    tabindex="0"
  >
    <span *ngIf="shouldShowPlaceholder()">{{ placeholder }}</span>
    <span *ngIf="shouldShowSelectedValue()">{{ getSelectedLabel() }}</span>
    <i class="bi bi-chevron-down float-end mt-1"></i>
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="dropdownOpen && !disabled"
    [cdkConnectedOverlayPositions]="overlayPositions"
    [cdkConnectedOverlayWidth]="menuWidth"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayFlexibleDimensions]="true"
    [cdkConnectedOverlayHasBackdrop]="true"
    cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
    (backdropClick)="closeDropdown()"
    (detach)="closeDropdown()"
  >
    <div class="dropdown-menu show">
      <div
        *ngIf="searchable"
        class="dropdown-search-wrap"
        (click)="$event.stopPropagation()"
      >
        <input
          class="dropdown-search-input"
          type="text"
          [(ngModel)]="searchQuery"
          placeholder="Search..."
          autocomplete="off"
        />
      </div>
      <div
        *ngFor="let option of filteredOptions; trackBy: trackByValue"
        class="dropdown-item"
        (click)="selectOption(option)"
      >
        {{ option.label }}
      </div>
      <div *ngIf="allowAddNew" class="dropdown-divider"></div>
      <div
        *ngIf="allowAddNew"
        class="dropdown-item add-more"
        (click)="onAddMore($event)"
      >
        <i class="bi bi-plus-circle me-2"></i>{{ addNewLabel }}
      </div>
    </div>
  </ng-template>
</div>
